import { render } from "./galleryModal.vue?vue&type=template&id=564e71ef&scoped=true&ts=true"
import script from "./galleryModal.vue?vue&type=script&lang=ts"
export * from "./galleryModal.vue?vue&type=script&lang=ts"

import "./galleryModal.vue?vue&type=style&index=0&id=564e71ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564e71ef"]])

export default __exports__